import { useState, useRef } from "react";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { PillInputBox } from "../../components/forms/form-inputs";
import { AppAlert } from "../../components/utilities/app-alert";

import { useLesson } from "../../services/lessons/lessons.context";
import { AppFooter } from "../../components/footer/footer";

export const CategoryAddPage = () => {

    const { isLoading, token } = useAuth();
    const { loading, createNewCategory } = useLesson();

    const [lessonData, setLessonData] = useState();
    const [onAlert, setOnAlert] = useState();
    const [filePrev, setFilePrev] = useState();

    const fileRef = useRef();

    const handleSetValue = (e) => {
        setLessonData((data) => ({
            ...data,
            [e.target.name]: e.target.value
        }))
    }


     const uploadFile = (e) => {
        if (e.target.files[0].type.split("/")[0].toLowerCase() !== "image") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type image",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setFilePrev(URL.createObjectURL(e.target.files[0]));
        setLessonData((d) => ({...d, documentFile: e.target.files[0]}));
    }


   
    const handleSubmit = async (e) => {
        e.preventDefault();
        const resp = await createNewCategory(lessonData, token);
        setOnAlert({
            caption: "Success!",
            message: resp.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert();
                setLessonData();
            }
        })

        //console.log(lessonData);
    }


    return (
        <div className="min-v">
            <AppHeader />
            {(isLoading || loading) && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="flx-cnt-pg">
                <div className={classNames("cap","lg-txt")}>Create a course category</div>
                <div className="sm-sp" />
                <form className="add-form" onSubmit={(e) => handleSubmit(e)}>
                    <PillInputBox
                        type={"text"}
                        name={"title"}
                        caption={"Category title"}
                        onChange={(e) => handleSetValue(e) }
                    />
                    
                    {filePrev && (
                        <div className="video-prev-box">
                            < img src={filePrev} width={250} />
                        </div>
                    )}
                    <button 
                        className="sel-click"
                        onClick={(e) => {
                            e.preventDefault();
                            fileRef.current.click();
                        }}
                    > Select an icon for the category
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadFile(e)}
                        className="file-sel"
                        ref={fileRef}
                    />
                    
                    <button 
                        className={classNames("form-button",'pill-input-box')}
                    >
                        Submit
                    </button>
                </form>
            </div>
            <AppFooter />
        </div>
    )
}